export type ProposalReportPageSpec =
  { kind: 'productGroups' } | { kind: 'topProducts' } | { kind: 'energy' };

type GetProposalReportPageSpecsInput = {
  hasProductGroupsData: boolean;
  hasTopProductsData: boolean;
  hasEnergyConsumption: boolean;
};

/**
 * Which per-proposal slides to render, in canvas order.
 *
 * Cover, summary and methodology are shared and assembled separately.
 * Empty chart data and missing B6 consumption omit those pages instead of
 * rendering blanks. Action slides were removed pending a redesign (DEV-3703).
 */
export const getProposalReportPageSpecs = ({
  hasProductGroupsData,
  hasTopProductsData,
  hasEnergyConsumption,
}: GetProposalReportPageSpecsInput): ProposalReportPageSpec[] => {
  const specs: ProposalReportPageSpec[] = [];

  if (hasProductGroupsData) specs.push({ kind: 'productGroups' });
  if (hasTopProductsData) specs.push({ kind: 'topProducts' });
  if (hasEnergyConsumption) specs.push({ kind: 'energy' });

  return specs;
};
